/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit MemberID/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function MemberID({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/Insurance/AssignedInsurance/Content/AssignedInsuranceItem/InsuredTreatments/Content/InsuredTreatment/Content/InsuredTreatmentItem/Payer/MemberID"
  
}) {
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
let txInsuredInsuranceSubscriptionMemberIdValueData = fromData.useDataValue({ viewPath,
context: 'tx',
path: 'insured.insurance_subscription.member_id',
})
  return (<React.Fragment
>
<div
  data-testid="MemberID.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 color={dtColorsNeutral500}
 text="Member ID:"
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="tx.insured.insurance_subscription.member_id"
 text={txInsuredInsuranceSubscriptionMemberIdValueData}
/>
</div>
{children}
</React.Fragment>)
}